// These names are "Common" outside mojo/trace
export class CommonClaimTypes {
  static readonly  Subject: string = 'sub';
  static readonly  Name: string = 'name';
  static readonly  GivenName: string = 'given_name';
  static readonly  FamilyName: string = 'family_name';
  static readonly  MiddleName: string = 'middle_name';
  static readonly  NickName: string = 'nickname';
  static readonly  PreferredUserName: string = 'preferred_username';
  static readonly  Profile: string = 'profile';
  static readonly  Picture: string = 'picture';
  static readonly  WebSite: string = 'website';
  static readonly  Email: string = 'email';
  static readonly  EmailVerified: string = 'email_verified';
  static readonly  Gender: string = 'gender';
  static readonly  BirthDate: string = 'birthdate';
  static readonly  ZoneInfo: string = 'zoneinfo';
  static readonly  Locale: string = 'locale';
  static readonly  PhoneNumber: string = 'phone_number';
  static readonly  PhoneNumberVerified: string = 'phone_number_verified';
  static readonly  Address: string = 'address';
  static readonly  Audience: string = 'aud';
  static readonly  Issuer: string = 'iss';
  static readonly  NotBefore: string = 'nbf';
  static readonly  Expiration: string = 'exp';
  static readonly  UpdatedAt: string = 'updated_at';
  static readonly  IssuedAt: string = 'iat';
  static readonly  AuthenticationMethod: string = 'amr';
  static readonly  SessionId: string = 'sid';
  static readonly  AuthenticationContextClassReference: string = 'acr';
  static readonly  AuthenticationTime: string = 'auth_time';
  static readonly  AuthorizedParty: string = 'azp';
  static readonly  AccessTokenHash: string = 'at_hash';
  static readonly  AuthorizationCodeHash: string = 'c_hash';
  static readonly  Nonce: string = 'nonce';
  static readonly  JwtId: string = 'jti';
  static readonly  Events: string = 'events';
  static readonly  ClientId: string = 'client_id';
  static readonly  Scope: string = 'scope';
  static readonly  Id: string = 'id';
  static readonly  IdentityProvider: string = 'idp';
  static readonly  Role: string = 'role';
  static readonly  ReferenceTokenId: string = 'reference_token_id';
  static readonly  Confirmation: string = 'cnf';

}
